import React, { createContext, useContext } from 'react'

import { useDataProvider } from '../hooks/useDataProvider'

export const DataProviderContext = createContext(null)

export const useDataProviderContext = () => useContext(DataProviderContext)

export const DataProviderProvider = ({
  httpClient,
  errorMessagesTrans = {},
  children
}) => {
  const fetcher = (resource, init) =>
    httpClient.get(resource, init).then(res => res.data)
  const dataProvider = useDataProvider('', httpClient)

  return (
    <DataProviderContext.Provider
      value={{ httpClient, fetcher, dataProvider, errorMessagesTrans }}
    >
      {children}
    </DataProviderContext.Provider>
  )
}
